import { Fragment } from 'react';
import {
  ItemContent,
  ItemTitle,
  DataContainer,
  DataItem,
} from './DataItems.styled';

export const DataItems = ({ items }) => {
  if (!items || !items.length) {
    return <DataContainer />;
  }

  return (
    <DataContainer>
      {items.filter(Boolean).map(({ title, data }, index) => (
        <DataItem key={`title-${title || index}`}>
          <ItemTitle key={`title-${title || index}`}>{title}</ItemTitle>
          <ItemContent key={`content-${title || index}`}>{data}</ItemContent>
        </DataItem>
      ))}
    </DataContainer>
  );
};

export default DataItems;
